/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { DetailsDataType } from "@/components/DetailsSection/types";

import {
  CONVEY_INTEGRATION_FIELD_NAMES,
  INTEGRATION_FIELD_NAMES
} from "../../../../../../../Pages/Integrations/types";
import { ROUTES } from "../../../../../../../shared";
import { useStyles } from "../../../../../styles";
import DetailsCard from "../../DetailsCard";
import DetailsCardItemText from "../../DetailsCardItemText";
import DetailsCardItemTitle from "../../DetailsCardItemTitle";

interface ConnectionSettingsProps {
  detailsData: DetailsDataType;
  route: ROUTES;
}

const ConnectionSettings = ({
  detailsData,
  route
}: ConnectionSettingsProps) => {
  const { t } = useTranslation();
  const { paperCardItem } = useStyles();

  if (!detailsData) return null;

  const fieldsSFTP = [
    { key: INTEGRATION_FIELD_NAMES.Host, value: detailsData.host },
    { key: INTEGRATION_FIELD_NAMES.Port, value: detailsData.port },
    {
      key: INTEGRATION_FIELD_NAMES.RemotePath,
      value: detailsData.directoryPath
    },
    { key: INTEGRATION_FIELD_NAMES.Username, value: detailsData.username },
    {
      key: INTEGRATION_FIELD_NAMES.Password,
      value: detailsData.passwordMasked
    }
  ];

  const fieldsConvey = [
    {
      key: CONVEY_INTEGRATION_FIELD_NAMES.EndpointUrl,
      value: detailsData.endpointUrl
    },

    {
      key: CONVEY_INTEGRATION_FIELD_NAMES.Username,
      value: detailsData.username
    },
    {
      key: CONVEY_INTEGRATION_FIELD_NAMES.Password,
      value: detailsData.passwordMasked
    }
  ];

  const fieldsToUse = route === ROUTES.Integrations ? fieldsSFTP : fieldsConvey;

  return (
    <DetailsCard cardTitle={t("Details##connection settings")}>
      {fieldsToUse.map(({ key, value }) => (
        <div key={key} css={css(paperCardItem)}>
          <DetailsCardItemTitle title={t(`Details##${key}`)} />
          <DetailsCardItemText textToRender={value} />
        </div>
      ))}
    </DetailsCard>
  );
};

export default ConnectionSettings;
